<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $t('messages.grades_report'),
                        href: null,
                    },
                    {
                        name: $t('messages.settings'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.store" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    <div>
                        {{ $t('messages.image') }}
                    </div>
                    <div>
                        <img :src="settings.image_path" alt="" />
                    </div>
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.image')" for="image" />
                            <input
                                id="image"
                                @input="form.image = $event.target.files[0]"
                                name="image"
                                type="file"
                                accept="image/*"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.image" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $tc('messages.tags', 2) }}
                </template>
                <div>
                    <div v-for="tagCategory in options.tagsByCategory" :key="tagCategory.id" class="mt-5">
                        <div class="text-semibold text-lg">
                            {{ tagCategory.display_name }}
                        </div>
                        <div class="flex space-x-2">
                            <label v-for="tag in tagCategory.tags" :key="tag.id">
                                <BadgePill :color="form.tag_ids.includes(tag.id) ? 'indigo' : 'gray'">
                                    <input type="checkbox" class="hidden" :value="tag.id" v-model="form.tag_ids" />
                                    {{ tag.name }}
                                </BadgePill>
                            </label>
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import BadgePill from '@/components/BadgePill.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        TitleFieldsFormSection,
        FormLabel,
        FormError,
        BadgePill,
    },
    layout: AdminLayout,
    name: 'Edit',
    props: ['settings', 'meta', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                _method: 'patch',
                tag_ids: this.settings.tag_ids,
                image: null,
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.update);
        },
    },
};
</script>
